import { useState } from 'react';
import { toast } from 'react-toastify';
import Button from 'components/button';
import {
  INFORMATION_SAVING_CODE,
  INFORMATION_SAVING_TEXT,
  INVOICE_IMPORT_STARTED,
  fillText,
  monthLabel,
} from 'components/invoiceImport/invoiceImportText';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';
import ApiDatabase from 'server';

/** "Importer les factures de [mois]" (JBWEB-1266, mockup 2.1). */
const ModalInvoiceImport = () => {
  const { toggle } = useModal();
  const { language, modalData, setModalDataReturn } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`invoiceImport.${key}`, fallback);
  const [isSending, setIsSending] = useState(false);
  const period = modalData?.period;

  const follow = (runId) => {
    setModalDataReturn({ type: INVOICE_IMPORT_STARTED, runId });
    toggle();
  };

  const confirm = () => {
    if (isSending || !period) return;
    setIsSending(true);
    ApiDatabase.postInvoiceImport(
      { period },
      (data) => {
        setIsSending(false);
        follow(data?.runId);
      },
      (error) => {
        if (error?.name === 'CanceledError') return;
        setIsSending(false);
        // Never the error object in the console: axios keeps the request, token included.
        const body = error?.response?.data;
        if (body?.errorCode === 'IMPORT_ALREADY_RUNNING' && body.runId) {
          toast.info(
            text(
              'alreadyRunning',
              'Un import de ce mois est déjà en cours : sa progression s’affiche.',
            ),
          );
          follow(body.runId);
          return;
        }
        if (body?.errorCode === INFORMATION_SAVING_CODE) {
          toast.info(
            text(INFORMATION_SAVING_TEXT.key, INFORMATION_SAVING_TEXT.fallback),
          );
          return;
        }
        if (body?.errorCode === 'PERIOD_INVALID') {
          toast.error(
            text('periodInvalid', 'Ce mois ne peut pas être importé.'),
          );
          return;
        }
        toast.error(
          text('startFailed', 'L’import n’a pas pu être lancé, réessayez.'),
        );
      },
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={!isSending}>
        {fillText(text('modalTitle', 'Importer les factures de {month}'), {
          month: period ? monthLabel(period) : '',
        })}
      </Modalheader>
      <ModalBody>
        <div className="ft-sm text-gray-500">
          {text(
            'modalText',
            'Les factures non importées et celles en erreur seront récupérées depuis Bestt, puis importées dans Pennylane.',
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          size="LG"
          color={isSending ? 'DISABLED' : 'SECONDARY'}
          disabled={isSending}
          onClick={toggle}
        >
          {text('cancel', 'Annuler')}
        </Button>
        <Button
          size="LG"
          color={isSending ? 'DISABLED' : 'PRIMARY'}
          disabled={isSending}
          onClick={confirm}
        >
          {isSending
            ? text('confirming', 'Lancement…')
            : text('confirm', 'Confirmer')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalInvoiceImport;
